import React from 'react';
import FillWord from '@components/FillWord';
import ReactResizeDetector from 'react-resize-detector';
import BG from '@assets/fillword-bg.png';
import './App.css';
import agent from '@src/agent';

class App extends React.Component {
  constructor() {
    super();

    this.state = {
      colorList: [],
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }

  componentWillMount() {
    this.generateColorList();
  }

  generateColorList () {
    let arr = [
      '#F13F82',
      '#FF6D43',
      '#C63CDA',
      '#9EF540',
      '#3ADF87',
      '#9EF540',
      '#ff80a4',
      '#ffcc3a',
      '#68bbf5',
      '#854df5',
      '#f54040',
      '#9ef5c5',
    ].sort(() => .5 - Math.random());

    arr.unshift('');

    this.setState({
      colorList: arr,
    });
  }

  render () {
    let size = 46;
    let width = 670;
    let className = '';
    let background = `url(${BG}) no-repeat`;

    if(this.state.width < width) {
      width = 'auto';
      size = 29;
      className = 'mobile';
      background = '';
    }

    return (
      <div className="App">
        <header className="App-header">
          <ReactResizeDetector handleWidth onResize={this.updateDimensions.bind(this)}>
            <div style={{background, width}} className={['fillword-wrapper', className].join(' ')}>
              <FillWord
                size={size}
                colorList={this.state.colorList}
                onComplete={this.onComplete.bind(this)}
                onWord={this.onWord.bind(this)}
              />
            </div>
          </ReactResizeDetector>
        </header>
      </div>
    );
  }

  onWord () {
    if('yaCounter38480375' in window) {
      window.yaCounter38480375.reachGoal('fillword_start');
    }
  }

  onComplete () {
    this.generateColorList();
    agent.FillWords.success();
    if('yaCounter38480375' in window) {
      window.yaCounter38480375.reachGoal('fillword');
    }
    alert('Вы разгадали филлворд!');
  }

  updateDimensions(width) {
    if(width !== undefined) {
      this.setState({width});
    }
  }
}

export default App;
